import { useState } from "react";
import Orders from "./Orders";
import Addresses from "./Addresses";
import Button from "./Button";
import RegistrationModal from "./RegistrationModal";
import ProductRegistrationForm from "./ProductRegistrationForm";

const Overview = ({ setPage }) => {
  const [regModalOpen, setRegModalOpen] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get("regModal") === "true";
  });

  return (
    <div>
      <div className="fade-up fade-up-delay-1">
        <Orders limit={4} />
      </div>
      <div className="flex mt-4 flex-wrap fade-up fade-up-delay-2">
        <div className="w-full lg:w-2/3 lg:mr-4">
          <Addresses limit={1} setPage={setPage} />
        </div>
        <div className="p-8 flex-grow box-shadow rounded-lg border-t-8 border-teal-500">
          <p className="font-bold text-xl m-0">Quick Actions</p>
          <div className="block pt-3">
            <a
              rel="noopener noreferrer"
              href="https://www.blizzardpro.com/support"
              target="_blank"
              className="text-slate-800 block pb-2"
            >
              Get Support
            </a>
            <a
              rel="noopener noreferrer"
              className="text-slate-800 block pb-2"
              href="https://www.portal.blizzardpro.com/?type=signup&newReseller=true"
              target="_blank"
            >
              Become a Reseller
            </a>
          </div>
        </div>
      </div>
      <div className="mt-8 fade-up fade-up-delay-3">
        <h2 className="text-2xl font-bold">Extend a Product's Warranty</h2>
        <p>Fill out a product registration form to extend eligible product warranties by 1-year</p>
        <Button title="Register Product" onClick={() => setRegModalOpen(true)} />
      </div>
      <RegistrationModal isOpen={regModalOpen} onClose={() => setRegModalOpen(false)}>
        <ProductRegistrationForm />
      </RegistrationModal>
    </div>
  );
};

export default Overview;
